const SCREEN_SIZE = {
	MOBILE: 480,
	TABLET: 768,
	DESKTOP: 1024,
};

export const DEVICE = {
	MOBILE: `(max-width: ${SCREEN_SIZE.MOBILE}px)`,
	TABLET: `(max-width: ${SCREEN_SIZE.TABLET}px)`,
	DESKTOP: `(max-width: ${SCREEN_SIZE.DESKTOP}px)`,
};

export { SCREEN_SIZE };